import { QueryClient } from "@tanstack/react-query";

const PRODUCT_LIST_COLUMNS = "id, name, price, offer_price, image, seo_slug, rating, stock, is_active, created_at, sizes, images, sku";
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

const headers: HeadersInit = {
  apikey: SUPABASE_KEY,
  Authorization: `Bearer ${SUPABASE_KEY}`,
};

const fetchViaRest = async (params: string) => {
  const res = await fetch(
    `${SUPABASE_URL}/rest/v1/products?select=${encodeURIComponent(PRODUCT_LIST_COLUMNS)}&${params}`,
    { headers }
  );
  return res.ok ? res.json() : [];
};

const prefetchMap: Record<string, () => { queryKey: string[]; queryFn: () => Promise<any> }> = {
  "/new-arrivals": () => ({
    queryKey: ["products", "new-arrivals-page"],
    queryFn: () => fetchViaRest("is_active=eq.true&order=created_at.desc&limit=20"),
  }),
  "/best-selling": () => ({
    queryKey: ["products", "best-selling-page"],
    queryFn: () => fetchViaRest("is_active=eq.true&order=rating.desc&limit=20"),
  }),
};

let prefetchedPaths = new Set<string>();

/**
 * Prefetch product data for a given path so it's ready when the user navigates.
 * Call on mouseEnter / touchStart of nav links.
 */
export const prefetchProductsForPath = (path: string, queryClient: QueryClient) => {
  if (prefetchedPaths.has(path)) return;
  const factory = prefetchMap[path];
  if (!factory) return;
  prefetchedPaths.add(path);
  const { queryKey, queryFn } = factory();
  queryClient.prefetchQuery({
    queryKey,
    queryFn,
    staleTime: 3 * 60 * 1000,
  });
};
